var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._l((_vm.roles),function(role,index){return _c('v-chip',{key:index,attrs:{"small":"","color":_vm.getColor(role),"dark":""}},[_vm._v(" "+_vm._s(role)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }